<template>
  <section class="featured-gifts">
    <div class="featured-gifts__header">
      <span class="featured-gifts__label">{{ data.label }}</span>
      <h2 class="featured-gifts__title">{{ data.title }}</h2>
    </div>

    <div class="featured-gifts__body">
      <div class="featured-gifts__left">
        <div class="featured-gifts__image">
          <img :src="data.mainImage" alt="" />
        </div>
        <h3 class="featured-gifts__lead">
          {{ data.lead }}
          <img
            class="featured-gifts__link-icon"
            src="@/assets/images/link2.png"
            alt=""
          />
        </h3>
        <p class="featured-gifts__desc">{{ data.description }}</p>
      </div>

      <div class="featured-gifts__right">
        <FocusCard
          v-for="(card, index) in data.cards"
          :key="index"
          :title="card.title"
          :subtitle="card.subtitle"
          :description="card.description"
          :image="card.image"
          :index="index"
        />
      </div>
    </div>
  </section>
</template>

<script>
import FocusCard from "./FocusCard.vue";

export default {
  name: "FeaturedGifts",
  components: { FocusCard },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.featured-gifts {
  background-color: #eee7d8;
  padding: 60px 40px 100px 40px;
  box-sizing: border-box;

  &__header {
    margin-bottom: 28px;
  }

  &__label {
    font-family: $font-family;
    font-size: 12px;
    font-weight: normal;
    color: #8c6b2f;
    letter-spacing: 1.5px;
    text-align: left;
    display: block;
    margin-bottom: 10px;
  }

  &__title {
    font-family: $font-family;
    font-size: 50px;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0;
    text-align: left;
  }

  &__body {
    display: flex;
    gap: 24px;
  }

  &__left {
    width: 560px;
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    gap: 18px;
    box-sizing: border-box;
  }

  &__image {
    border-radius: 16px;
    overflow: hidden;
    flex: 1;

    img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: fill;
    }
  }

  &__lead {
    font-family: $font-family;
    font-size: 32px;
    font-weight: 700;
    color: #1a1a1a;
    line-height: 1.04;
    margin: 0;
    text-align: left;
    display: flex;
    align-items: flex-end;
    gap: 10px;
  }

  &__link-icon {
    width: 18px;
    height: 18px;
    object-fit: contain;
    flex-shrink: 0;
  }

  &__desc {
    font-family: $font-family;
    font-size: 15px;
    font-weight: normal;
    color: #5f5a54;
    line-height: 1.72;
    margin: 0;
    text-align: left;
  }

  &__right {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 18px;
  }

  @include tablet {
    padding: 40px 32px 60px 32px;

    &__left {
      width: 460px;
    }

    &__title {
      font-size: 40px;
    }
  }

  @include mobile {
    padding: 32px 20px;

    &__header {
      margin-bottom: 16px;
    }

    &__label {
      font-size: 11px;
    }

    &__title {
      font-size: 30px;
    }

    &__body {
      flex-direction: column;
      gap: 18px;
    }

    &__left {
      width: 100%;
      gap: 12px;
    }

    &__image {
      height: 200px;
      flex: none;
    }

    &__lead {
      font-size: 24px;
    }

    &__desc {
      font-size: 14px;
    }

    &__right {
      gap: 14px;
    }
  }
}
</style>
